define("shared/types/image", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MimeType = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let MimeType = _exports.MimeType = /*#__PURE__*/function (MimeType) {
    MimeType["Apng"] = "image/apng";
    MimeType["Avi"] = "video/x-msvideo";
    MimeType["Avif"] = "image/avif";
    MimeType["Bmp"] = "image/bmp";
    MimeType["Gif"] = "image/gif";
    MimeType["Jpeg"] = "image/jpeg";
    MimeType["Jpg"] = "image/jpg";
    MimeType["Mov"] = "video/quicktime";
    MimeType["Mp4"] = "video/mp4";
    MimeType["Mpeg"] = "video/mpeg";
    MimeType["Ogg"] = "video/ogg";
    MimeType["Png"] = "image/png";
    MimeType["Svg"] = "image/svg";
    MimeType["Tiff"] = "image/tiff";
    MimeType["Webm"] = "video/webm";
    MimeType["Webp"] = "image/webp";
    return MimeType;
  }({});
});